import { createAction, props } from '@ngrx/store';

export const setTemplateOrderStatus = createAction(
  '[Fb] Set Template Order Status',
  props<{ templateOrderStatus: boolean }>() // ✅ ici
);

export const setIdBOT = createAction(
  '[Fb] Set ID BOT',
  props<{ idBOT: string }>()
);

export const setCollection = createAction(
  '[Fb] Set Collection',
  props<{ collection: string }>()
);
